import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { clearRecurrenceData } from '../../../redux/slices/lomavisCreator/lomavisCreator';
import { useTranslate } from '@tolgee/react';
import { VIEW_STATUS } from '../config/constants';

const DeleteConfirmation = ({ handleCancel, show, handleDelete, keyText }) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  return (
    <div>
      <Modal centered show={show} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${keyText}.confirmation.header`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t(`${keyText}.confirmation.main`)}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              handleCancel();
            }}
            variant="secondary"
            size="sm"
          >
            {t('lomavisCreator.modal.cancel')}
          </Button>
          <Button size="sm" variant="danger" onClick={handleDelete}>
            {t('lomavisCreator.modal.Delete')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeleteConfirmation;
